import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CheckIcon, SparklesIcon, BookOpenIcon, HeadphonesIcon, AudioLinesIcon, LayersIcon, GiftIcon } from 'lucide-react';
export function NEXUSSection() {
  return <SectionWrapper id="nexus" withGlow data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 mb-6 bg-[#16213e] border border-[#c9a84c]/50 rounded-full shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-214">
            <SparklesIcon className="w-4 h-4 text-[#f0d060]" aria-hidden="true" data-id="element-215" />
            <span className="text-[#f0d060] text-sm font-bold tracking-wider uppercase gold-shimmer" data-id="element-216">
              Sistema NEXUS
            </span>
          </div>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-6 leading-tight" data-id="element-217">
            El protocolo completo de{' '}
            <span className="text-gold-gradient" data-id="element-218">
              reprogramación de identidad
            </span>
          </h2>

          <p className="text-lg md:text-xl text-[#9a9aab] max-w-2xl mx-auto leading-relaxed" data-id="element-219">
            Todo lo que necesitas para instalar tu nueva identidad en 21 días.
            <span className="text-[#e8e6e1] font-medium" data-id="element-220">
              {' '}
              Sin fricción. Sin decisiones.
            </span>
          </p>
        </div>

        {/* Main NEXUS Card */}
        <div className="rounded-2xl p-8 md:p-12 mb-12 relative" style={{
        background: 'linear-gradient(135deg, #16213e 0%, #1a1a2e 100%)',
        border: '2px solid rgba(201,168,76,0.4)',
        boxShadow: '0 0 40px rgba(201,168,76,0.15), inset 0 0 30px rgba(201,168,76,0.05)'
      }} data-id="element-221">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.15) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-222" />

          <div className="relative" data-id="element-223">
            {/* Product Image */}
            <div className="flex justify-center mb-8" data-id="element-224">
              <img src="https://cdn.magicpatterns.com/uploads/rgFVDCDuF2GSCMQwuPwg5Z/private_openrouter-generated-image-1771189315301.png" alt="Sistema NEXUS" className="h-48 object-contain drop-shadow-[0_0_30px_rgba(201,168,76,0.4)]" loading="eager" data-id="element-225" />
            </div>

            <div className="text-center mb-10" data-id="element-226">
              <h3 className="font-display text-2xl md:text-3xl font-bold gold-shimmer mb-4" data-id="element-227">
                Sistema NEXUS™
              </h3>
              <p className="text-[#9a9aab] text-sm tracking-[0.2em] uppercase mb-6" data-id="element-228">
                Neuro-Espiritual de Transformación Unificada del Ser
              </p>
              <p className="text-lg md:text-xl text-[#e8e6e1] max-w-2xl mx-auto leading-relaxed" data-id="element-229">
                El nivel más profundo de reprogramación mental y espiritual.
                <span className="text-[#c9a84c] font-medium" data-id="element-230">
                  {' '}
                  Todo incluido.
                </span>
              </p>
            </div>

            {/* What's Included */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-231">
              <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0f0f1e]/60 border border-[#3a3a5c]/50" data-id="element-232">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-233">
                  <BookOpenIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-234" />
                </div>
                <div data-id="element-235">
                  <h4 className="text-[#e8e6e1] font-semibold mb-1" data-id="element-236">
                    Ebook Completo
                  </h4>
                  <p className="text-[#9a9aab] text-sm" data-id="element-237">
                    El protocolo paso a paso para reprogramar tu identidad en 21
                    días
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0f0f1e]/60 border border-[#3a3a5c]/50" data-id="element-238">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-239">
                  <HeadphonesIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-240" />
                </div>
                <div data-id="element-241">
                  <h4 className="text-[#e8e6e1] font-semibold mb-1" data-id="element-242">
                    Audiobook (+50 min)
                  </h4>
                  <p className="text-[#9a9aab] text-sm" data-id="element-243">
                    Escucha el protocolo completo narrado profesionalmente
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0f0f1e]/60 border border-[#3a3a5c]/50" data-id="element-244">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-245">
                  <AudioLinesIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-246" />
                </div>
                <div data-id="element-247">
                  <h4 className="text-[#e8e6e1] font-semibold mb-1" data-id="element-248">
                    7 Audios Subconscientes
                  </h4>
                  <p className="text-[#9a9aab] text-sm" data-id="element-249">
                    Reprogramación con frecuencias específicas mientras duermes
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0f0f1e]/60 border border-[#3a3a5c]/50" data-id="element-250">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-251">
                  <GiftIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-252" />
                </div>
                <div data-id="element-253">
                  <h4 className="text-[#e8e6e1] font-semibold mb-1" data-id="element-254">
                    10 Bonos Prácticos
                  </h4>
                  <p className="text-[#9a9aab] text-sm" data-id="element-255">
                    Ejercicios, plantillas y guías de implementación inmediata
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0f0f1e]/60 border border-[#3a3a5c]/50 md:col-span-2" data-id="element-256">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-257">
                  <LayersIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-258" />
                </div>
                <div data-id="element-259">
                  <h4 className="text-[#e8e6e1] font-semibold mb-1" data-id="element-260">
                    Sistema Completo de Integración
                  </h4>
                  <p className="text-[#9a9aab] text-sm" data-id="element-261">
                    El framework para integrar todos los elementos y hacer el
                    cambio permanente
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="border-t border-[#3a3a5c] pt-8 mb-10" data-id="element-262">
              <h4 className="text-center text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-263">
                Lo que experimentarás
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-264">
                <div className="flex items-center gap-3" data-id="element-265">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-266" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-267">
                    Claridad mental total
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-268">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-269" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-270">
                    Ejecución sin resistencia
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-271">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-272" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-273">
                    Disciplina de identidad
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-274">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-275" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-276">
                    Paz interior genuina
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-277">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-278" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-279">
                    Control sobre tu mente
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-280">
                  <CheckIcon className="w-5 h-5 text-[#f0d060] flex-shrink-0" aria-hidden="true" data-id="element-281" />
                  <span className="text-[#e8e6e1] text-sm" data-id="element-282">
                    Propósito claro
                  </span>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center" data-id="element-283">
              <a href="https://pay.hotmart.com/L104469229P?bid=1772161592044" target="_blank" rel="noopener noreferrer" onClick={() => {
              const f = window as any;
              if (f.fbq) f.fbq('track', 'InitiateCheckout');
              setTimeout(() => {
                window.location.href = 'https://pay.hotmart.com/L104469229P?bid=1772161592044';
              }, 500);
            }} className="inline-flex items-center justify-center gap-3 px-12 py-6 text-xl
                  font-semibold tracking-wide text-[#1a1a2e]
                  bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c] bg-[length:200%_auto]
                  rounded-lg cta-pulse
                  transition-all duration-500 ease-out
                  hover:bg-[position:right_center] hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(201,168,76,0.5)]
                  active:scale-[0.98]
                  focus:outline-none focus:ring-2 focus:ring-[#f0d060] focus:ring-offset-2 focus:ring-offset-[#1a1a2e]
                  cursor-pointer" style={{
              textDecoration: 'none'
            }} data-id="element-284">
                ⭐ Acceder a NEXUS Ahora ⭐
              </a>
              <p className="text-[#6b6b7b] text-sm mt-4" data-id="element-285">
                Acceso inmediato · Pago único · Acceso de por vida
              </p>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="text-center p-6 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-286">
          <p className="text-[#9a9aab] text-sm" data-id="element-287">
            <span className="text-[#e8e6e1] font-semibold" data-id="element-288">
              Garantía de 21 días:
            </span>{' '}
            Si aplicas el protocolo y no experimentas un cambio real, te
            devolvemos el 100%. Sin preguntas.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}